// extracted by mini-css-extract-plugin
export default {"container":"AboutTemplate_container__ukH7+","decoration":"AboutTemplate_decoration__IFUEQ","decoration_large":"AboutTemplate_decoration_large__jLKoa"};